// removed by extract-text-webpack-plugin
module.exports = {"cards":"cards_cards_1yGmu","card":"cards_card_SsXWH","orange":"cards_orange_1uTgl","icons":"cards_icons_g_-F4","icon":"cards_icon_20heL","lato-title":"cards_lato-title_1R_HJ lato-title","lato-subtitle":"cards_lato-subtitle_YwyG8 lato-subtitle"};


//////////////////
// WEBPACK FOOTER
// ./src/static/home/cards/cards.css
// module id = 419
// module chunks = 4